import FlexSearch from "flexsearch";
import type { DocumentGroup } from "./document-group";
import type { SearchResult } from "./search-result";

// Vytvoření instance FlexSearch Document
const index = new FlexSearch.Document({
	document: {
		id: "slug",
		index: ["title", "content", "headings[]:title"],
		store: ["title", "slug", "group", "order"],
	},
	tokenize: "full", // nebo "forward" ale "full" je univerzálnější
	preset: "match", // zapne předdefinované normální chování
});

export function createIndex(groups: DocumentGroup[]) {
	groups.forEach((group) => {
		group.documents.forEach((document) => {
			index.add({
				slug: document.slug.join("/"),
				title: document.title,
				// content: document.content ?? "",
				headings: document.headings?.map((h) => ({ title: h.title })) ?? [],
				order: document.order,
				group: group.label,
			});
		});
	});
}

export function search(query: string): SearchResult[] {
	const results = index.search(query, {
		enrich: true, // Zahrnout původní data dokumentu
	});

	if (results.length === 0) {
		return [];
	}

	const payload: SearchResult[] = [];

	results.forEach((result) => {
		result.result.forEach((item) => {
			if (!payload.find((p) => p.slug === item.doc?.slug)) {
				payload.push({
					slug: item.doc?.slug as string,
					title: item.doc?.title as string,
					order: item.doc?.order as number,
					groupTitle: item.doc?.group as string,
				});
			}
		});
	});

	return payload;
}
